import { render, staticRenderFns } from "./Synths.vue?vue&type=template&id=e9ccf8c6&"
import script from "./Synths.vue?vue&type=script&lang=js&"
export * from "./Synths.vue?vue&type=script&lang=js&"
import style0 from "./Synths.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports